<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :rules="rules">
      <OCheckbox v-model="model" :disabled="normalizedDisabled" @change="(attrs.onChange)"></OCheckbox>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormCheckboxProps } from './Checkbox'
import OCheckbox from '../../Input/Checkbox/Checkbox.vue'
import { useFormItemDisabled, useFormItemModel, useFormItemSpan } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormCheckbox', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, rules } = defineProps<FormCheckboxProps>()
const normalizedSpan = useFormItemSpan()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
